import { Fragment, memo } from 'react';
import { ICON_COLOR } from '@zep-us/zus/tokens';
import { useTranslation } from 'next-i18next';
import { SquareStackIcon, TrashIcon } from '@/icons';
import { AiGenerateSimilarQuizModal } from '../AiGenerateSimilarQuizModal';
import { useEditMode } from '../focus/useIsEditMode';
import { useQuizList } from '../useQuizList';
import { useAiGenerateSubjectiveStatusValue } from './Subjective/AiGenerateSingleAnswer/useAiGeneateSubjectiveStatus';
import { EditableHint } from './EditableHint';
import { EditTools } from './EditTools';
import { useQuizControl } from './QuizControlProvider';
import { EditableSubjective } from './Subjective';
export const SubjectiveBody = memo(({
  leftSlot
}: {
  leftSlot: React.ReactNode;
}) => {
  const {
    index
  } = useQuizControl();
  const {
    handleCopy,
    handleDelete
  } = useQuizList();
  const {
    isEditMode
  } = useEditMode();
  const {
    generatingIndexes,
    isGeneratingBulk
  } = useAiGenerateSubjectiveStatusValue();
  const {
    t
  } = useTranslation(['common', 'build']);
  const editToolsDisabled = generatingIndexes.length > 0 || isGeneratingBulk;
  return <Fragment>
        <div className="flex flex-row justify-between" onClick={e => e.stopPropagation()}>
          {leftSlot}
          <div className="flex flex-row items-center gap-xs">
            {!isEditMode && <>
                <AiGenerateSimilarQuizModal />
                <EditTools.Divider />
              </>}
            <EditTools.QuizDuplicateButton disabled={editToolsDisabled} />
            <EditTools.QuizDeleteButton disabled={editToolsDisabled} />
            <EditTools.EditToolsDrawer disabled={editToolsDisabled} tools={[{
          icon: <SquareStackIcon size="md" fill={ICON_COLOR.default} />,
          label: t('global.duplicate.button'),
          onClick: () => handleCopy(index)
        }, {
          icon: <TrashIcon size="md" fill={ICON_COLOR.default} />,
          label: t('global.delete'),
          onClick: () => {
            void handleDelete(index);
          }
        }]} />
          </div>
        </div>

        <div className="flex flex-col justify-between gap-xs" onClick={e => e.stopPropagation()}>
          <EditableSubjective />
          <EditableHint />
        </div>
      </Fragment>;
});